import Proptypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ActionsMenu } from '@piplapps/pipl-ui';
import { UsersActions } from '../../../Redux/modules/users/actions';
import styles from './ActionMenu.module.less';

const ActionMenu = (props) => {
  const { data, actions } = props;
  useEffect(() => {
    props.setCurrentUser(data);
  }, []);
  return (
    <div>
      <ActionsMenu
        actions={actions}
        context={data}
        trigger={
          <button className={styles.primaryBlue} type="button" test-id="action-menu-table">
            {gettext('Actions')}
          </button>
        }
      />
    </div>
  );
};

ActionMenu.propTypes = {
  data: Proptypes.object,
  actions: Proptypes.array,
  setCurrentUser: Proptypes.func,
};

const mapDispatchToProps = {
  setCurrentUser: UsersActions.setCurrentClickedUser,
};

export default connect(null, mapDispatchToProps)(ActionMenu);
